import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { Usuario } from '../usuario/usuario';
import { UsuariosService } from '../usuarios/usuarios.service';

@Component({
  selector: 'app-remover-usuarios',
  templateUrl: './remover-usuarios.component.html',
  styleUrls: ['./remover-usuarios.component.css'],
  providers: [
	UsuariosService
   ]
})
export class RemoverUsuariosComponent implements OnInit {

	usuario: Usuario;
  perfis: any;

  constructor(private usuariosService: UsuariosService, private route: ActivatedRoute, private router: Router) {
	this.usuario = new Usuario();
  }

	obterDadosUsuario(){

		this.route.params.forEach((params: Params) => {
		 let id = params['id'];

		 if (id !== undefined) {

			this.usuariosService.getUsuario(id).then((usuario) => {
        this.usuario.nome = usuario['dados'].nome;
        this.usuario.login = usuario['dados'].login;
        this.usuario.email = usuario['dados'].email;

        let cpf = usuario['dados'].cpf;
        let cpfFormatado  = cpf.substr( 0, 3 ) + '.';
        cpfFormatado += cpf.substr( 3, 3 ) + '.';
        cpfFormatado += cpf.substr( 6, 3 ) + '-';
        cpfFormatado += cpf.substr( 9, 2 ) + '';
        this.usuario.cpf = cpfFormatado;

        this.perfis = usuario['dados'].perfis;
			}).catch(() => this.goBack());
		 }
	   });
	}

	removerDadosUsuario(){
		this.route.params.forEach((params: Params) => {
		 let id = params['id'];

		 if (id !== undefined) {
			this.usuariosService.removeUsuario(id).then(result => {
				this.goBack();
			}).catch(error => console.log(error));
		 }
	   });
	}

	ngOnInit() {
		this.obterDadosUsuario();
	}

	goBack(): void {
		this.router.navigate(['usuarios']);
	}

}



// WEBPACK FOOTER //
// ./src/app/remover-usuarios/remover-usuarios.component.ts